var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplePlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35,
    cy: 35,
    r: 35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,2.8c17.8,0,32.2,14.4,32.2,32.2c0,17.8-14.4,32.2-32.2,32.2C17.2,67.2,2.8,52.8,2.8,35 C2.8,17.2,17.2,2.8,35,2.8z M35,70c19.3,0,35-15.7,35-35S54.3,0,35,0S0,15.7,0,35S15.7,70,35,70z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,53.5c0,0-2.6,3.4-19.2,3.4c-16.6,0-19.6-3.4-19.6-3.4V48c0-0.7,0.2-1,0.9-1.3c2.2-0.9,8.1-3,11.8-4.1 c1.9-0.6,1.9-2.3,1.9-3.5c0-1.7-0.2-3-0.7-4c-0.4-0.8-0.9-2.2-1-3.4L27.7,31l-0.5-0.5c-0.2-0.3-0.9-1.1-1.3-3.2 c-0.3-1.6-0.2-2-0.1-2.3c0.1-0.2,0.1-0.3,0.2-0.5l0,0l0-0.1c0.2-1-0.1-4.2-0.4-5.9c-0.1-0.8,0-3,1.5-4.9c0.9-1.1,2.7-2.5,5.9-2.8 h2.2c2.7,0.2,4.7,1.1,6,2.8c1.5,1.9,1.7,4.1,1.5,4.9c-0.3,1.7-0.6,4.8-0.4,5.9l0,0.1l0,0.1c0,0.1,0.1,0.2,0.1,0.4l0,0 c0.1,0.3,0.3,0.7,0,2.3c-0.4,2.1-1,2.9-1.3,3.2L40.8,31l-0.1,0.7c-0.2,1.2-0.6,2.6-1,3.4c-0.5,1.1-1.1,2.5-1.1,4c0,1.2,0,2.9,2,3.5 c3.6,1,9.5,3,11.9,4c0.9,0.4,1.2,1,1.2,1.4L53.7,53.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplePlaceholder);
export default __webpack_public_path__ + "static/media/people_placeholder.8ddf67e3333765d48884086d47f23f4a.svg";
export { ForwardRef as ReactComponent };